import React from "react";
import { useRecommendedFeaturesSectionStyles } from "./RecommendedFeaturesSectionStyles";
import { MBox, MTypography } from "@material-dev/insights-portal-ui-components";
import { CardDetails } from "../Types/types";
import FeatureCard from "../FeatureCard";

const RecommendedFeaturesSection: React.FC = () => {
  const { classes } = useRecommendedFeaturesSectionStyles();

  const featureCardList: CardDetails[] = [
    { title: 'Similarity Checker', hyperLink:"https://material.freshservice.com/support/solutions/articles/22000032362-Similarity-Checker" },
    { title: 'Relevancy Checker', hyperLink:"https://help.materialplus.io/support/solutions/articles/22000078726" },
    { title: 'Translations', hyperLink:"https://help.materialplus.io/support/solutions/articles/22000069758" },
    { title: 'SPSS Download',  hyperLink:"https://help.materialplus.io/support/solutions/articles/22000078725" },
  ];

  return (
    <MBox className={classes.root}>
      <MTypography className={classes.title}>Recommended documents</MTypography>
      <MBox className={classes.features}>
        {featureCardList.map((feature, index) => (
          <FeatureCard key={index} {...feature} />          
        ))}
      </MBox>
    </MBox>
  );
};

export default RecommendedFeaturesSection;
